import React from "react";

// state
import { IEditBlog, IEditErrorBlog } from "../../../store/types/blog";
import { useAppSelector } from "../../../store";

const useEditBlog = () => {
  const blog = useAppSelector(({ blog }) => blog.blog);
  const [data, setData] = React.useState<IEditBlog>({
    title: "",
    feature_image: "",
    slug: "",
    excerpt: "",
    body: "",
    is_published: false,
    category_id: 0,
    id: "",
  });

  const [error, setError] = React.useState<IEditErrorBlog>({
    feature_image: "",
    title: "",
    slug: "",
    excerpt: "",
    body: "",
    category_id: "",
    id: "",
  });

  const onValidate = () => {
    const requiredMessage = "error: this field is required" as const;
    const errors: IEditErrorBlog = {
      feature_image: data.feature_image ? "" : requiredMessage,
      title: data.title.trim() ? "" : requiredMessage,
      slug: data.slug.trim() ? "" : requiredMessage,
      excerpt: data.excerpt.trim() ? "" : requiredMessage,
      body: data.body.trim() ? "" : requiredMessage,
      category_id: data.category_id > 0 ? "" : requiredMessage,
      id: data.id.trim() ? "" : requiredMessage,
    };
    setError(errors);
    return Object.values(errors).every((message) => !message);
  };

  const onLoad = React.useCallback(() => {
    if (blog) {
      setData({
        title: blog.title || "",
        slug: blog.slug || "",
        excerpt: blog.excerpt || "",
        feature_image: blog.feature_image || blog.image || "",
        body: blog.body || blog.article || "",
        is_published: blog.is_published ?? blog.published === "1",
        category_id: blog.category_id ?? (Number(blog.category?.id) || 0),
        id: String(blog.id),
      });
    }
  }, [blog]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  return {
    data,
    error,
    setData,
    setError,
    onValidate,
  };
};

export default useEditBlog;
